import styled from 'styled-components';
import { Typography } from '../../../assets/styles/StyleTypes';

export const Paragraph = styled.p`
  text-align: center;
  ${Typography.BODY_XS}
  color: ${(props) => props.theme.colors.textPrimary};
`;

export const Link = styled.a`
  color: #396BC9;
  cursor: pointer;
  font-size: 13px;
  font-weight: 450;
  letter-spacing: 0.18px;
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  text-decoration: none;

  svg {
    fill: #396BC9;
  }
`;
